import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

/** Sentinel value for filtering assets that have no importance set (null/empty) */
export const FILTER_IMPORTANCE_NONE = '__none__';

const hasNoImportance = (value: string | null | undefined): boolean => value == null || value === '';

/**
 * Filters recommended assets by search term and importance
 */
export const filterRecommendedAssets = (assets: RecommendedAsset[], search: string, importance?: string): RecommendedAsset[] => {
  if (!assets || !Array.isArray(assets)) {
    return [];
  }

  let filtered = assets;

  if (importance && importance !== 'all') {
    if (importance === FILTER_IMPORTANCE_NONE) {
      filtered = filtered.filter(asset => hasNoImportance(asset.importance));
    } else {
      filtered = filtered.filter(asset => asset.importance === importance);
    }
  }

  if (!search) return filtered;

  const searchLower = search.toLowerCase();
  return filtered.filter(
    asset =>
      asset?.name?.toLowerCase().includes(searchLower) ||
      asset?.owner?.profile?.firstName?.toLowerCase().includes(searchLower) ||
      asset?.owner?.profile?.lastName?.toLowerCase().includes(searchLower) ||
      asset?.owner?.email?.toLowerCase().includes(searchLower) ||
      asset?.category?.name?.toLowerCase().includes(searchLower) ||
      asset?.type?.toLowerCase().includes(searchLower),
  );
};

/**
 * Filters available assets by search term, excludes recommended ones, and filters by importance
 */
export const filterAvailableAssets = (
  availableAssets: AssetItem[],
  recommendedAssets: RecommendedAsset[],
  search: string,
  importance?: string,
): AssetItem[] => {
  if (!availableAssets) return [];

  const recommendedIds = new Set(recommendedAssets.map(a => a.id));
  let filtered = availableAssets.filter(asset => !recommendedIds.has(asset.id));

  if (importance && importance !== 'all') {
    if (importance === FILTER_IMPORTANCE_NONE) {
      filtered = filtered.filter(asset => hasNoImportance(asset.importance));
    } else {
      filtered = filtered.filter(asset => asset.importance === importance);
    }
  }

  if (search) {
    const searchLower = search.toLowerCase();
    filtered = filtered.filter(
      asset =>
        asset.name.toLowerCase().includes(searchLower) ||
        asset.owner.fullName.toLowerCase().includes(searchLower) ||
        asset.owner.email.toLowerCase().includes(searchLower) ||
        (asset.category && asset.category.name.toLowerCase().includes(searchLower)),
    );
  }

  return filtered;
};
